module.exports = __webpack_public_path__ + "dist/poster.88e0543d.jpg";